import React, { useState } from 'react';

const Support = () => {
    const [activeTab, setActiveTab] = useState('faqs');

    return (
        <div className="container-fluid py-5">
            <div className="row justify-content-center">
                <div className="col-lg-12">
                    <div className="card border-0 shadow-lg rounded-4 overflow-hidden">
                        <div className="card-body p-0">
                            {/* Header with gradient background */}
                            <div className="bg-primary bg-gradient p-4 mb-4">
                                <h1 className="text-white fw-bold mb-3">Support Center</h1>

                                {/* Tabs with pill styling */}
                                <ul className="nav nav-pills">
                                    <li className="nav-item me-2">
                                        <button
                                            className={`nav-link px-4 py-2 ${activeTab === 'faqs' ? 'active bg-white text-primary' : 'text-white border border-white'}`}
                                            onClick={() => setActiveTab('faqs')}
                                            style={{ borderRadius: '30px', fontWeight: 500 }}
                                        >
                                            FAQs
                                        </button>
                                    </li>
                                    <li className="nav-item d-none">
                                        <button
                                            className={`nav-link px-4 py-2 ${activeTab === 'tickets' ? 'active bg-white text-primary' : 'text-white border border-white'}`}
                                            onClick={() => setActiveTab('tickets')}
                                            style={{ borderRadius: '30px', fontWeight: 500 }}
                                        >
                                            Support Tickets
                                        </button>
                                    </li>
                                </ul>
                            </div>

                            {/* Content container with padding */}
                            <div className="px-4 px-md-5 pb-5">
                                {activeTab === 'faqs' ? (
                                    /* FAQs Tab Content */
                                    <div>
                                        <h2 className="mb-4 fw-bold text-primary">Frequently Asked Questions</h2>

                                        <div className="accordion" id="faqAccordion">
                                            <div className="accordion-item border-0 shadow-sm mb-3 rounded-3">
                                                <h3 className="accordion-header">
                                                    <button className="accordion-button rounded-3 fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne">
                                                        How do I train my chatbot?
                                                    </button>
                                                </h3>
                                                <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#faqAccordion">
                                                    <div className="accordion-body">
                                                        <p className="text-secondary mb-0">Navigate to the Document Upload page and upload relevant PDF or TXT files.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="accordion-item border-0 shadow-sm mb-3 rounded-3">
                                                <h3 className="accordion-header">
                                                    <button className="accordion-button rounded-3 fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo">
                                                        Can I customize the chatbot theme?
                                                    </button>
                                                </h3>
                                                <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                                                    <div className="accordion-body">
                                                        <p className="text-secondary mb-0">Yes, go to the Chat Customization page to modify colors and fonts.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="accordion-item border-0 shadow-sm rounded-3">
                                                <h3 className="accordion-header">
                                                    <button className="accordion-button rounded-3 fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree">
                                                        How does document training work?
                                                    </button>
                                                </h3>
                                                <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                                                    <div className="accordion-body">
                                                        <p className="text-secondary mb-0">Uploaded documents are processed to expand the chatbot's knowledge base.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    /* Support Tickets Tab Content */
                                    <div>
                                        <div className="row">
                                            <div className="col-lg-6 pe-lg-4">
                                                <h2 className="mb-4 fw-bold text-primary">Your Tickets</h2>

                                                <div className="card mb-3 border-0 shadow-sm hover-shadow rounded-3 position-relative overflow-hidden">
                                                    <div className="position-absolute h-100" style={{ width: '6px', background: '#dc3545', left: 0, top: 0 }}></div>
                                                    <div className="card-body p-4">
                                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                                            <h5 className="card-title mb-0 fw-bold">Chatbot not responding</h5>
                                                            <span className="badge bg-danger text-white px-3 py-2 rounded-pill">Open</span>
                                                        </div>
                                                        <p className="text-muted mb-0 small">Created: 4/8/2025</p>
                                                        <hr className="my-3" />
                                                        <div className="d-flex align-items-center">
                                                            <i className="bi bi-chat-left-text me-2"></i>
                                                            <span>Last update: 2 hours ago</span>
                                                            <button className="btn btn-sm btn-outline-primary ms-auto rounded-pill px-3">View Details</button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="card mb-3 border-0 shadow-sm hover-shadow rounded-3 position-relative overflow-hidden">
                                                    <div className="position-absolute h-100" style={{ width: '6px', background: '#ffc107', left: 0, top: 0 }}></div>
                                                    <div className="card-body p-4">
                                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                                            <h5 className="card-title mb-0 fw-bold">Training document upload issue</h5>
                                                            <span className="badge bg-warning text-dark px-3 py-2 rounded-pill">In Progress</span>
                                                        </div>
                                                        <p className="text-muted mb-0 small">Created: 4/8/2025</p>
                                                        <hr className="my-3" />
                                                        <div className="d-flex align-items-center">
                                                            <i className="bi bi-chat-left-text me-2"></i>
                                                            <span>Last update: 1 day ago</span>
                                                            <button className="btn btn-sm btn-outline-primary ms-auto rounded-pill px-3">View Details</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-6 ps-lg-4 mt-5 mt-lg-0">
                                                <div className="card border-0 shadow rounded-4 p-4">
                                                    <div className="card-body">
                                                        <h2 className="mb-4 fw-bold text-primary">Create New Ticket</h2>

                                                        <form>
                                                            <div className="mb-4">
                                                                <label className="form-label fw-medium">Ticket Title</label>
                                                                <input type="text" className="form-control form-control-lg border-0 bg-light" placeholder="Enter a descriptive title" />
                                                            </div>

                                                            <div className="mb-4">
                                                                <label className="form-label fw-medium">Category</label>
                                                                <select className="form-select form-select-lg border-0 bg-light">
                                                                    <option>Chatbot Issue</option>
                                                                    <option>Training Problem</option>
                                                                    <option>Account Access</option>
                                                                    <option>Billing Question</option>
                                                                    <option>Other</option>
                                                                </select>
                                                            </div>

                                                            <div className="mb-4">
                                                                <label className="form-label fw-medium">Description</label>
                                                                <textarea className="form-control border-0 bg-light" style={{ minHeight: "150px" }} placeholder="Describe your issue in detail"></textarea>
                                                            </div>

                                                            <div className="mb-4">
                                                                <label className="form-label fw-medium">Attachments (Optional)</label>
                                                                <div className="input-group">
                                                                    <input type="file" className="form-control border-0 bg-light" />
                                                                </div>
                                                            </div>

                                                            <div className="d-grid">
                                                                <button type="submit" className="btn btn-primary btn-lg rounded-pill py-3">
                                                                    <i className="bi bi-send me-2"></i>Submit Ticket
                                                                </button>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// CSS to add to your styles.css
// .hover-shadow:hover {
//   transform: translateY(-3px);
//   box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
//   transition: all 0.3s ease;
// }

export default Support;